import React from "react";
import dynamic from "next/dynamic";
const ButtonLink = dynamic(() => import("@/Components/ButtonLink"),{ssr: true});
import { toWebp } from "@/utils/common";

interface UseCasesCardProps {
  title?: string;
  description?: string;
  imageUrl?: string;
  buttonLabel?: string;
  buttonLink?: string;
}

const UseCasesCard: React.FC< UseCasesCardProps> = ({ title = "Light-Out Factory",
  description = "Leveraged AI/ML technologies to streamline inventory management, enabling real-time tracking, demand forecasting, and reduced stock discrepancies in manufacturing.",
  imageUrl = "/images/ServicesInner/ai-service_usecases02.jpg",
  buttonLabel,
  buttonLink,
 }) => {
  return (
    <div className="caseCard h-full">
      <div
        className="w-full h-full xl:min-h-[593px] md:min-h-[480px] min-h-[593px] max-h-[593px] flex flex-col justify-between"
        style={{
          backgroundImage: `url(${toWebp(imageUrl)})`,
          backgroundSize: "cover",
        }}
      >
        <div className="bg-border">
          <p
            className={`text-center text-blue-900 pt-1 text-[16px] font-regular !leading-[22px] mx-auto`}
          >
            Use Case
          </p>
        </div>
        <div className="bg-[linear-gradient(180deg,_rgba(0,_0,_0,_0.08)_0%,_rgba(0,_0,_0,_0.8)_60.02%)] py-6 px-4 grow flex flex-col justify-end">
          <div>
            <div className=" caseCardHeight">
              <h3 className="xl:text-heading-3  lg:text-heading-4 text-heading-3 font-bold text-primary-text-white">
                {title}
              </h3>
              <p className="text-subtitle-2 font-regular text-secondary-text-white mt-2.5 xl:line-clamp-none line-clamp-5">
                {description}
              </p>
            </div>
            {buttonLink && buttonLabel && (
              <ButtonLink
                label={buttonLabel}
                href={buttonLink}
                className="mt-2.5"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default UseCasesCard;